export default __webpack_public_path__ + "static/120-09bb8863311b5565061a4da3d4802f96.jpg";